import React from "react";
import html5 from "../../../assets/logo/skills/html5.png";
import css3 from "../../../assets/logo/skills/css3.png";
import bootstrap from "../../../assets/logo/skills/bootstrap.png";
import tailwind from "../../../assets/logo/skills/tailwind.png";
import js from "../../../assets/logo/skills/js.png";
import github from "../../../assets/logo/skills/github.png";
import reactjs from "../../../assets/logo/skills/reactjs.png";
import nodejs from "../../../assets/logo/skills/nodejs.png";
import express from "../../../assets/logo/skills/express.png";
import mongo from "../../../assets/logo/skills/mongo.png";
import firebase from "../../../assets/logo/skills/firebase.png";
import python from "../../../assets/logo/skills/python.png";
import figma from "../../../assets/logo/skills/figma.png";
import jwt from "../../../assets/logo/skills/jwt.png";
import ai from "../../../assets/logo/skills/ai.png";
import ps from "../../../assets/logo/skills/ps.png";
import pr from "../../../assets/logo/skills/pr.png";
import vercel from "../../../assets/logo/skills/vercel.png";
import netlify from "../../../assets/logo/skills/netlify.png";

const Skills = () => {
  return (
    <div className="bg-primary pb-20">
      <div className="container mx-auto">
        <h2 className="text-accent lg:text-start md:text-center sm:text-center text-center lg:text-7xl md:text-5xl sm:text-3xl text-3xl pb-20 font-semibold hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500 hover:text-green-400">
          SKILLS
        </h2>
        <div className="grid lg:grid-cols-6 md:grid-cols-3 sm:grid-cols-3 grid-cols-3 gap-12 mx-auto">
          <div className="flex flex-col items-center hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500 hover:text-green-400">
            <img
              src={html5}
              alt=""
              className="hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500"
            />
            <p className="text-accent text-center mt-2 text-sm hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500 hover:text-green-400">
              HTML5
            </p>
          </div>
          <div className="flex flex-col items-center hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500 hover:text-green-400">
            <img
              src={css3}
              alt=""
              className="hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500"
            />
            <p className="text-accent text-center mt-2 text-sm hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500 hover:text-green-400">
              CSS3
            </p>
          </div>
          <div className="flex flex-col items-center hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500 hover:text-green-400">
            <img
              src={bootstrap}
              alt=""
              className="hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500"
            />
            <p className="text-accent text-center mt-2 text-sm hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500 hover:text-green-400">
              Bootstrap
            </p>
          </div>
          <div className="flex flex-col items-center hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500 hover:text-green-400">
            <img
              src={tailwind}
              alt=""
              className="hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500"
            />
            <p className="text-accent text-center mt-2 text-sm hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500 hover:text-green-400">
              TailwindCSS
            </p>
          </div>
          <div className="flex flex-col items-center hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500 hover:text-green-400">
            <img
              src={js}
              alt=""
              className="hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500"
            />
            <p className="text-accent text-center mt-2 text-sm hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500 hover:text-green-400">
              Javascript
            </p>
          </div>
          <div className="flex flex-col items-center hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500 hover:text-green-400">
            <img
              src={github}
              alt=""
              className="hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500"
            />
            <p className="text-accent text-center mt-2 text-sm hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500 hover:text-green-400">
              Github
            </p>
          </div>
          <div className="flex flex-col items-center hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500 hover:text-green-400">
            <img
              src={reactjs}
              alt=""
              className="hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500"
            />
            <p className="text-accent text-center mt-2 text-sm hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500 hover:text-green-400">
              ReactJS
            </p>
          </div>
          <div className="flex flex-col items-center hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500 hover:text-green-400">
            <img
              src={nodejs}
              alt=""
              className="hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500"
            />
            <p className="text-accent text-center mt-2 text-sm hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500 hover:text-green-400">
              NodeJS
            </p>
          </div>
          <div className="flex flex-col items-center hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500 hover:text-green-400">
            <img
              src={express}
              alt=""
              className="hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500"
            />
            <p className="text-accent text-center mt-2 text-sm hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500 hover:text-green-400">
              ExpressJS
            </p>
          </div>
          <div className="flex flex-col items-center hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500 hover:text-green-400">
            <img
              src={mongo}
              alt=""
              className="hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500"
            />
            <p className="text-accent text-center mt-2 text-sm hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500 hover:text-green-400">
              MongoDB
            </p>
          </div>
          <div className="flex flex-col items-center hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500 hover:text-green-400">
            <img
              src={firebase}
              alt=""
              className="hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500"
            />
            <p className="text-accent text-center mt-2 text-sm hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500 hover:text-green-400">
              FIREBASE
            </p>
          </div>
          <div className="flex flex-col items-center hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500 hover:text-green-400">
            <img
              src={jwt}
              alt=""
              className="hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500"
            />
            <p className="text-accent text-center mt-2 text-sm hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500 hover:text-green-400">
              JSON WEB TOKEN
            </p>
          </div>
          <div className="flex flex-col items-center hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500 hover:text-green-400">
            <img
              src={netlify}
              alt=""
              className="hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500"
            />
            <p className="text-accent text-center mt-2 text-sm hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500 hover:text-green-400">
              NETLIFY
            </p>
          </div>
          <div className="flex flex-col items-center hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500 hover:text-green-400">
            <img
              src={vercel}
              alt=""
              className="hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500"
            />
            <p className="text-accent text-center mt-2 text-sm hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500 hover:text-green-400">
              VERCEL
            </p>
          </div>
          <div className="flex flex-col items-center hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500 hover:text-green-400">
            <img
              src={python}
              alt=""
              className="hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500"
            />
            <p className="text-accent text-center mt-2 text-sm hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500 hover:text-green-400">
              PYTHON
            </p>
          </div>
          <div className="flex flex-col items-center hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500 hover:text-green-400">
            <img
              src={figma}
              alt=""
              className="hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500"
            />
            <p className="text-accent text-center mt-2 text-sm hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500 hover:text-green-400">
              FIGMA
            </p>
          </div>
          <div className="flex flex-col items-center hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500 hover:text-green-400">
            <img
              src={ai}
              alt=""
              className="hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500"
            />
            <p className="text-accent text-center mt-2 text-sm hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500 hover:text-green-400">
              ADOBE ILLUSTRATOR
            </p>
          </div>
          <div className="flex flex-col items-center hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500 hover:text-green-400">
            <img
              src={ps}
              alt=""
              className="hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500"
            />
            <p className="text-accent text-center mt-2 text-sm hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500 hover:text-green-400">
              ADOBE PHOTOSHOP
            </p>
          </div>
          <div className="flex flex-col items-center hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500 hover:text-green-400">
            <img
              src={pr}
              alt=""
              className="hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500"
            />
            <p className="text-accent text-center mt-2 text-sm hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500 hover:text-green-400">
              ADOBE PREMIERE PRO
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Skills;
